/**
 * Search Console / SEO is hidden from Ads Center and Admin → Marketing
 * (PR #1255 review: the practice wants paid-media dashboards, not SEO).
 * Hidden, not removed: flip this to true and every SEO item comes back.
 * The API still serves the Search Console data and keeps any connection
 * a practice already made.
 */
export const SEARCH_CONSOLE_VISIBLE = false;
